import { render, staticRenderFns } from "./freeToEnjoy.vue?vue&type=template&id=34ff1844&scoped=true"
import script from "./freeToEnjoy.vue?vue&type=script&lang=js"
export * from "./freeToEnjoy.vue?vue&type=script&lang=js"
import style0 from "./freeToEnjoy.vue?vue&type=style&index=0&id=34ff1844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ff1844",
  null
  
)

export default component.exports